import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled, { css } from 'styled-components';
import Box from './Box';
var SECTION_TYPES = {
  medium: {
    $py: [32, 60],
    paddingBottom: [64, 120]
  },
  large: {
    $py: [48, 88],
    paddingBottom: [48, 88]
  },
  minimal: {
    $py: 0,
    paddingBottom: 0
  }
};
// ! --offset-top-0 and --offset-bottom-0
var Section = styled(Box).attrs(function (_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'medium' : _ref$type,
      props = _objectWithoutProperties(_ref, _excluded);

  var $py = SECTION_TYPES[type].$py;
  return _objectSpread({
    $py: $py,
    as: 'section'
  }, props);
}).withConfig({
  displayName: "Section",
  componentId: "sc-wg2rl9-0"
})(["", " ", " ", " ", ""], function (_ref2) {
  var background = _ref2.background,
      theme = _ref2.theme;
  return background && css(["background:", ";"], theme.colors[background]);
}, function (_ref3) {
  var theme = _ref3.theme,
      _ref3$$withLastChildP = _ref3.$withLastChildPadding,
      $withLastChildPadding = _ref3$$withLastChildP === void 0 ? true : _ref3$$withLastChildP,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'medium' : _ref3$type;
  return $withLastChildPadding && css(["&:last-child{", "}"], theme.normalizeStyles({
    paddingBottom: SECTION_TYPES[type].paddingBottom
  }));
}, function (_ref4) {
  var $noPaddingTop = _ref4.$noPaddingTop;
  return $noPaddingTop && css(["padding-top:0;"]);
}, function (_ref5) {
  var $noPaddingBottom = _ref5.$noPaddingBottom;
  return $noPaddingBottom && css(["padding-bottom:0;"]);
});
export default Section;